import React, { useState, useRef } from 'react';
import cx from 'classnames';
export const Tooltip = ({ text, children }) => {
    const [coords, setCoords] = useState({
        x: 0,
        y: 0,
    });
    const [isOpen, setIsOpen] = useState(false);
    const openingTimeout = useRef(undefined);
    const showTooltip = (event) => {
        // If the mouse is too low, raise the tooltip up higher
        // Right hand overflow is not currently handled
        const pageHeight = document.documentElement.clientHeight;
        const mouseY = event.clientY;
        const minYOffset = 50;
        const yCoord = pageHeight - mouseY <= minYOffset ? event.pageY - 20 : event.pageY + 15;
        setCoords({ x: event.pageX + 15, y: yCoord });
    };
    return (React.createElement("div", { className: "tooltip_wrapper", onMouseEnter: () => {
            openingTimeout.current = setInterval(() => setIsOpen(true), 800);
        }, onMouseMove: showTooltip, onMouseLeave: () => {
            if (openingTimeout.current !== null) {
                clearTimeout(openingTimeout.current);
            }
            setIsOpen(false);
        } },
        React.createElement("span", { className: cx('tooltip', { 'tooltip-open': isOpen, 'tooltip-hide': text === '' }), style: { top: coords.y, left: coords.x } }, text),
        children));
};
//# sourceMappingURL=Tooltip.js.map